import {
  CreateReportPublicRequest,
  CreateReportRequest,
  CreateReportResponse,
  PlaceReport,
  PlaceReportPublic,
  CreateReportPublicResponse,
  CreateReportsRequest,
} from '../types';
import axiosInstance from './axiosInstance';

export async function createReport(req: CreateReportRequest) {
  const response = await axiosInstance.post(`/reports`, req, {
    // 2 minute timeout
    timeout: 120000,
  });
  return response.data as CreateReportResponse;
}

export async function createReports(req: CreateReportsRequest) {
  const data: CreateReportResponse[] = [];
  for (const place_id of req.place_ids) {
    const response = await createReport({
      place_id,
      contact: req.contact,
      business_type: req.business_type,
    });
    data.push(response);
  }
  return data;
}

export async function getReport(uuid: string) {
  const response = await axiosInstance.get(`/reports/${uuid}`);
  return response.data as PlaceReport;
}

export async function createReportPublic(req: CreateReportPublicRequest) {
  const response = await axiosInstance.post(`/reports/public`, req);
  return response.data as CreateReportPublicResponse;
}

export async function getReportPublic(public_code: string) {
  const response = await axiosInstance.get(`/reports/public/${public_code}`);
  return response.data as PlaceReportPublic;
}

export async function downloadReportPdf(uuid: string, period: string) {
  const response = await axiosInstance.get(`/reports/${uuid}/${period}/pdf`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
}
